(function () {
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
  }

  function applyGuard(cartTotalCents) {
    document.querySelectorAll('.moq-warning').forEach(function (box) {
      var threshold = parseInt(box.dataset.moqThreshold, 10);
      var form = box.closest('form');
      var checkoutBtn = form ? form.querySelector('[name="checkout"]') : document.querySelector('[name="checkout"]');
      var blocked = cartTotalCents < threshold;

      box.hidden = !blocked;
      var amountEl = box.querySelector('.moq-warning-amount');
      if (amountEl) amountEl.textContent = formatMoney(threshold);

      if (checkoutBtn) {
        checkoutBtn.disabled = blocked;
        checkoutBtn.setAttribute('data-moq-blocked', blocked ? 'true' : 'false');
      }
    });
  }

  function refresh() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyGuard(cart.total_price); })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.documentElement.addEventListener('cart:change', function () { setTimeout(refresh, 0); });
  document.documentElement.addEventListener('cart:update', function () { setTimeout(refresh, 0); });
})();